import React, { useEffect } from 'react';
import { connect } from 'react-redux';

import TopFooter from './TopFooter/TopFooter';
import BottomFooter from './BottomFooter/BottomFooter';

import './Footer.scss';
import ServicesFooter from './ServicesFooter/ServicesFooter';
import Assistenza from '../../shared/Icons/Assistenza';
import PuntiRitiro from '../../shared/Icons/PuntiRitiro';
import Phone from '../../shared/Icons/Phone';
import Spedizione from '../../shared/Icons/Spedizione';
import Pagamenti from '../../shared/Icons/Pagamenti';
import DiscountLineBanner from '../../routes/Home/ImageBanners/DiscountLineBanner';
import chroma from 'chroma-js';

import { loadPages } from '../../../redux/modules/pages';
import lightOrDark from '../SlickArrow/colorArrowFunction';
import moment from 'moment/moment';

const Footer = props => {
  const {
    siteName,
    datiFarmacia,
    logoImage,
    logoFooterLink,
    isCheckout,
    primaryColor,
    showDiscountsLinkInFooter,
    homePageConfiguration,
    secondaryColor,
    advImages,
    discounted,
    footerTextField,
  } = props;

  useEffect(() => {
    props.loadPages();
  }, []);

  const services = [
    {
      id: 1,
      title: 'Aiuto e supporto',
      icon: <Assistenza />,
      url: '/pagine/contattaci',
    },
    {
      id: 2,
      title: datiFarmacia.phone,
      icon: <Phone />,
      action: `tel:${datiFarmacia.phone}`,
    },
    {
      id: 3,
      title: 'Consegne',
      icon: <Spedizione />,
      url: '/pagine/modalita-costi-spedizione',
    },
    {
      id: 4,
      title: 'Pagamenti',
      icon: <Pagamenti />,
      url: '/pagine/pagamenti-accettati',
    },
  ];

  const getFooter = module => {
    const imageBannerConfig = homePageConfiguration.find(
      item => item.moduleType === 'Image_banner'
    );
    return (
      <footer
        style={{
          backgroundColor:
            module.moduleVersion === 1
              ? chroma(secondaryColor).darken(3.5)
              : '#f8f8f8',
          paddingTop: module.moduleVersion === 2 ? '48px' : '0px',
        }}
      >
        {module.moduleVersion === 2 && imageBannerConfig ? (
          <DiscountLineBanner advImages={advImages} />
        ) : null}

        <TopFooter
          imageBannerConfig={imageBannerConfig}
          footerTextField={footerTextField}
          isCheckout={isCheckout}
          datiFarmacia={datiFarmacia}
          logoImage={logoImage}
          logoFooterLink={logoFooterLink}
          siteName={siteName}
          primaryColor={primaryColor}
          secondaryColor={secondaryColor}
          showDiscountsLinkInFooter={showDiscountsLinkInFooter}
          footerVersion={module.moduleVersion}
          discounted={discounted}
          pages={props.pages}
        />
        {module.moduleVersion === 3 && (
          <ServicesFooter
            services={services}
            primaryColor={primaryColor}
            secondaryColor={secondaryColor}
            datiFarmacia={datiFarmacia}
            footerVersion={module.moduleVersion}
          />
        )}
        <hr
          style={{
            border:
              module.moduleVersion === 1
                ? '1px solid rgba(255, 255, 255, 0.5)'
                : '1px solid rgba(0, 0, 0, 0.5)',
            display: module.moduleVersion === 3 && 'none',
            maxWidth: module.moduleVersion === 1 ? '95%' : '100%',
            marginTop: module.moduleVersion === 2 ? '16px' : '0px',
          }}
        ></hr>

        <BottomFooter
          primaryColor={primaryColor}
          datiFarmacia={datiFarmacia}
          footerVersion={module.moduleVersion}
          secondaryColor={secondaryColor}
        />

        <div
          style={{
            background: primaryColor,
            minHeight: 48,
            marginTop: module.moduleVersion === 3 ? 0 : 16,
            padding: 16,
            color: lightOrDark(primaryColor) === 'dark' ? '#fff' : '#000',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            fontSize: 14,
            textAlign: 'center',
          }}
        >
          Copyright © {moment().year()} {datiFarmacia.companyName} - P. IVA: IT
          {datiFarmacia.vatCode} - {datiFarmacia.email}
        </div>
      </footer>
    );
  };

  return (
    <>
      {homePageConfiguration.map(module => {
        if (module.moduleType === 'Footer') {
          return getFooter(module);
        }
      })}
    </>
  );
};

const mapStateToProps = state => ({
  homePageConfiguration: state.store.data.home.homePageConfiguration,
  advImages: state.store.data.home.advImages,
  siteName: state.store.data.datiFarmacia.siteName,
  datiFarmacia: state.store.data.datiFarmacia,
  logoFooterLink: state.store.data.datiFarmacia.logoFooterLink,
  logoImage:
    state.store.data.loghiTemplate.logoFooterImage ||
    state.store.data.loghiTemplate.logoImage,
  primaryColor: state.store.data.loghiTemplate.brandColor,
  secondaryColor: state.store.data.loghiTemplate.secondaryColor,
  showDiscountsLinkInFooter:
    state.store.data.loghiTemplate.showDiscountsLinkInFooter,
  feedaty: {
    enabled: state.store.data.features.hasFeedaty,
    widgetId: state.store.data.integrazioni.feedaty.widgetId,
    siteKey: state.store.data.integrazioni.feedaty.siteKey,
  },
  discounted: state.homeProducts.data.discounted,
  pages: state.pages.data,
  footerTextField: state.store.data.funzionalita.footerTextField,
});

export default connect(mapStateToProps, { loadPages })(Footer);
